import styled from 'styled-components';
import { colors, fonts, screenSize } from 'styleGuide';

export const StyledArticle = styled.article`
  margin: 0.94rem auto;
  padding: 1.87rem 0.94rem;
  width: 15.31rem;
  height: 19.37rem;
  box-shadow: 0px 1px 6px ${({ theme }) => theme.black.alpha(0.1)};
  background-color: ${colors.white};
  display: flex;
  flex-direction: column;
  position: relative;
  img {
    height: 2.2rem;
    max-width: 10.37rem;
  }
  &:before {
    content: '';
    height: 19.37rem;
    width: 15.31rem;
    position: absolute;
    top: -6px;
    left: -6px;
    z-index: -1;
    background-color: ${colors.pink.pale};
  }
  .quote {
    font-family: ${fonts.austinBold};
    font-size: 3.12rem;
    color: ${colors.blue.primary};
    margin: 0.94rem 0;
  }
  p {
    flex-grow: 1;
    margin-top: -0.94rem;
  }
  a {
    align-self: flex-end;
  }
`;

export const CarouselContainer = styled.div`
  @media (min-width: ${screenSize.laptop}) {
    .alice-carousel__dots {
      display: none;
    }
  }
  @media (min-width: ${screenSize.laptopL}) {
    padding: 0 9.06rem;
  }
`;
